import React from "react";
import styles from "./styles.module.scss";
import { Spin, Timeline } from "antd";
import { LogItemInfo } from "../../../../../../../../service/exam";
interface Props {
    data: LogItemInfo | null;
    loading: boolean;
}
export default function AllExamLog({ loading, data }: Props) {
    return (
        <div className={styles.root}>
            <Spin spinning={loading}>
                <div className={styles.examLog}>
                    系统操作记录
                    <br />
                    <br />
                    <Timeline>
                        {data?.logDetail?.map((item, index) => (
                            <Timeline.Item key={item.TIME + item.desc + index}>
                                {item.desc} - {item.TIME}
                            </Timeline.Item>
                        ))}
                    </Timeline>
                </div>
            </Spin>
        </div>
    );
}
